import CompanyBillingHistoryCard from './CompanyBillingHistoryCard';
import CompanyBillingInformationCard from './CompanyBillingInformationCard';
import CompanyBillingNotificationsCard from './CompanyBillingNotificationsCard';
import { EDITOR_ROLES } from './overviewLayout';

/**
 * The « Factures » tab of the company panel, shown with the invoice access
 * only: the billing information (JBWEB-1268), who receives the invoices
 * (JBWEB-1285) and the company's invoices by year (JBWEB-1308). Editing
 * follows the same roles as the overview.
 */
const SlideOverCompanyInvoicesTab = ({ companyInfo, userData }) => {
  const canEdit = EDITOR_ROLES.includes(userData?.role);

  return (
    <>
      <CompanyBillingInformationCard
        idCompany={companyInfo?._id}
        canEdit={canEdit}
      />
      <CompanyBillingNotificationsCard
        idCompany={companyInfo?._id}
        canEdit={canEdit}
      />
      <CompanyBillingHistoryCard idCompany={companyInfo?._id} />
    </>
  );
};

export default SlideOverCompanyInvoicesTab;
